jQuery(document).ready(function($) {
    // Mobile-Navigation: ausklappbare Submenüs mit Chevron
    var $mobileMenu = $('#mobile-menu');

    if ($mobileMenu.length) {
        var chevron =
            '<button class="submenu-toggle" type="button" aria-expanded="false" aria-label="Untermenü öffnen">' +
                '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
                    '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
            '</button>';

        $mobileMenu.find('.menu-item-has-children').each(function() {
            $(this).children('a').first().after(chevron);
        });

        $mobileMenu.on('click', '.submenu-toggle', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var $btn = $(this);
            var $li = $btn.closest('.menu-item-has-children');
            var $sub = $li.children('.sub-menu');
            var willOpen = !$li.hasClass('is-open');

            $li.toggleClass('is-open');
            $btn.attr('aria-expanded', willOpen);
            $sub.stop(true, true).slideToggle(250);
        });
    }
});
